import styled from 'styled-components/macro'

/**
 * span HTML element that keeps its content on one line
 */
export const NoWrap = styled.span`
  white-space: nowrap;
`
